import React from 'react';
import PropTypes from 'prop-types';

function DiscountAndTrade({ translate }) {
  return (
    <div className='trade-benefit-section'>
      <div className='trade-benefit trade-benefit-header right-header'>
        <div className='font-title'>{translate('Heading.BenefitMuchMore')}</div>
      </div>
      <div className='desktop-view'>
        <div className='div-table more-benefit-container'>
          <div className='div-table-row'>
            <div className='div-table-cell benefit-item'>
              <div className='icon-robux-130x130'>
                <span className='icon-ten-percent-more' />
              </div>
            </div>
            <div className='div-table-cell benefit-item'>
              <div className='icon-trade-160x160' />
            </div>
          </div>
          <div className='div-table-row'>
            <div className='div-table-cell'>
              <div className='font-title benefit-title benefit-item'>
                {translate('Heading.MoreRobux')}
              </div>
            </div>
            <div className='div-table-cell'>
              <div className='font-title benefit-title benefit-item'>
                {translate('Label.Trade')}
              </div>
            </div>
          </div>
          <div className='div-table-row'>
            <div className='div-table-cell'>
              <div className='font-header-2 benefit-desc benefit-item'>
                {translate('Description.ExtraRobux', { extra: 10 })}
              </div>
            </div>
            <div className='div-table-cell'>
              <div className='font-header-2 benefit-desc benefit-item'>
                {translate('Description.TradeUnlockSubtitle')}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mobile-view'>
        <div className='div-table more-benefit-container'>
          <div className='div-table-row'>
            <div className='div-table-cell'>
              <div className='font-title benefit-title benefit-item'>
                {translate('Heading.MoreRobux')}
              </div>
              <div className='font-header-2 benefit-desc benefit-item'>
                {translate('Description.ExtraRobux', { extra: 10 })}
              </div>
            </div>
            <div className='div-table-cell benefit-item'>
              <div className='icon-robux-130x130'>
                <span className='icon-ten-percent-more' />
              </div>
            </div>
          </div>
          <div className='div-table-row'>
            <div className='div-table-cell benefit-item'>
              <div className='icon-trade-160x160' />
            </div>
            <div className='div-table-cell'>
              <div className='font-title benefit-title benefit-item'>
                {translate('Label.Trade')}
              </div>
              <div className='font-header-2 benefit-desc benefit-item'>
                {translate('Description.TradeUnlockSubtitle')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

DiscountAndTrade.propTypes = {
  translate: PropTypes.func.isRequired
};

export default DiscountAndTrade;
